import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

export const getPaymentByNim = createAsyncThunk("paymentInfo/getPaymentByNim", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/payment/info/nim/${request}`);
    return response.data;
});

export const getPaymentByParam = createAsyncThunk("paymentInfo/getPaymentByParam", async (payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/payment/info/param', payload);
    return response.data;
});

export const reportPaymentDate = createAsyncThunk("paymentInfo/reportPaymentDate", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/payment/info/date`,val);
    return response.data;
});

export const disbPaymentDate = createAsyncThunk("paymentInfo/disbPaymentDate", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/disbursement/filter/date`,val);
    return response.data;
});

export const tambahPembayaranMultiple = createAsyncThunk("pay/tambahPembayaran", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    //const response = await jwtAuthAxios.post(`v1/payment-detail/trx/${val}`);
    const response = await jwtAuthAxios.post('v1/add/pay/multiple',val);
    return response.data;
});

export const hapusPembayaranMultiple = createAsyncThunk("pay/hapusPembayaranMultiple", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    //const response = await jwtAuthAxios.post(`v1/payment-detail/trx/${val}`);
    const response = await jwtAuthAxios.post('v1/add/pay/hapus',val);
    return response.data;
});

export const reportTunggakanPembayaran = createAsyncThunk("paymentInfo/reportTunggakanPembayaran", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/payment/info/tunggakan`,val);
    return response.data;
});

export const reportPembayaranLunas = createAsyncThunk("paymentInfo/reportPembayaranLunas", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/payment/info/lunas`,val);
    return response.data;
});

export const letak_kampus_findAll = createAsyncThunk("default/letakKampus_findAll", async (val) => {
    try {
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common[ 'Authorization' ] = 'Bearer ' + token;
        const url = `v1/master/pembayaran`
        const response = await jwtAuthAxios.get(url)
        return response.data
    } catch (response) {
        throw response
    }
});

export const searchListGeneratePayment = createAsyncThunk("paymentInfo/searchListGeneratePayment", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/generate/payment/search`,val);
    return response.data;
});
export const generateListGeneratePayment = createAsyncThunk("paymentInfo/generateListGeneratePayment", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/generate/payment/create`,val);
    return response.data;
});

const initialState = {
    loadingAddPayment: false,
    loadingPayment: false,
    loadingDisbursement: false,
    dataPayment : [],
    dataDisbursement : [],
    responseAddPay : {},
    dataLaporanTunggakan : [],
    dataLaporanLunas : [],
    dataLetakKampusAll: [],
    loading : false,
    dataGeneratePayment : {},
    loadingGeneratePayment : false,
    resultGeneratePayment : {},
}


const paymentInfoSlice = createSlice({
    name:"paymentInfo",
    initialState: initialState,
    reducers: {
        onRefreshGeneratePayment: (state) => {
            state.resultGeneratePayment = {}
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(letak_kampus_findAll.pending, (state) => {
                state.loading = true;
            })
            .addCase(letak_kampus_findAll.fulfilled, (state, action) => {
                state.dataLetakKampusAll = action.payload;
                state.loading = false;
            })
            .addCase(letak_kampus_findAll.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(searchListGeneratePayment.pending, (state) => {
                state.loadingGeneratePayment = true;
            })
            .addCase(searchListGeneratePayment.fulfilled, (state, action) => {
                state.dataGeneratePayment = action.payload;
                state.loadingGeneratePayment = false;
            })
            .addCase(searchListGeneratePayment.rejected, (state, action) => {
                state.loadingGeneratePayment = false;
            })

        builder
            .addCase(generateListGeneratePayment.pending, (state) => {
                state.loadingGeneratePayment = true;
            })
            .addCase(generateListGeneratePayment.fulfilled, (state, action) => {
                state.resultGeneratePayment = action.payload;
                state.loadingGeneratePayment = false;
            })
            .addCase(generateListGeneratePayment.rejected, (state, action) => {
                state.loadingGeneratePayment = false;
            })

        builder
            .addCase(reportPembayaranLunas.pending, (state) => {
                state.loadingPayment = true;
            })
            .addCase(reportPembayaranLunas.fulfilled, (state, action) => {
                state.dataLaporanLunas = action.payload;
                state.loadingPayment = false;
            })
            .addCase(reportPembayaranLunas.rejected, (state, action) => {
                state.loadingPayment = false;
            })

        builder
            .addCase(reportTunggakanPembayaran.pending, (state) => {
                state.loadingPayment = true;
            })
            .addCase(reportTunggakanPembayaran.fulfilled, (state, action) => {
                state.dataLaporanTunggakan = action.payload;
                state.loadingPayment = false;
            })
            .addCase(reportTunggakanPembayaran.rejected, (state, action) => {
                state.loadingPayment = false;
            })

        builder
            .addCase(hapusPembayaranMultiple.pending, (state) => {
                state.loadingAddPayment = true;
            })
            .addCase(hapusPembayaranMultiple.fulfilled, (state, action) => {
                state.responseAddPay = action.payload;
                state.loadingAddPayment = false;
            })
            .addCase(hapusPembayaranMultiple.rejected, (state, action) => {
                state.loadingAddPayment = false;
            })
        builder
            .addCase(tambahPembayaranMultiple.pending, (state) => {
                state.loadingAddPayment = true;
            })
            .addCase(tambahPembayaranMultiple.fulfilled, (state, action) => {
                state.responseAddPay = action.payload;
                state.loadingAddPayment = false;
            })
            .addCase(tambahPembayaranMultiple.rejected, (state, action) => {
                state.loadingAddPayment = false;
            })
        builder
            .addCase(getPaymentByNim.pending, (state) => {
                state.loadingPayment = true;
            })
            .addCase(getPaymentByNim.fulfilled, (state, action) => {
                state.dataPayment = action.payload;
                state.loadingPayment = false;
            })
            .addCase(getPaymentByNim.rejected, (state, action) => {
                state.loadingPayment = false;
            })
        builder
            .addCase(getPaymentByParam.pending, (state) => {
                state.loadingPayment = true;
            })
            .addCase(getPaymentByParam.fulfilled, (state, action) => {
                state.dataPayment = action.payload;
                state.loadingPayment = false;
            })
            .addCase(getPaymentByParam.rejected, (state, action) => {
                state.loadingPayment = false;
            })
        builder
            .addCase(reportPaymentDate.pending, (state) => {
                state.loadingPayment = true;
            })
            .addCase(reportPaymentDate.fulfilled, (state, action) => {
                state.dataPayment = action.payload;
                state.loadingPayment = false;
            })
            .addCase(reportPaymentDate.rejected, (state, action) => {
                state.loadingPayment = false;
            })
        builder
            .addCase(disbPaymentDate.pending, (state) => {
                state.loadingDisbursement = true;
            })
            .addCase(disbPaymentDate.fulfilled, (state, action) => {
                state.dataDisbursement = action.payload;
                state.loadingDisbursement = false;
            })
            .addCase(disbPaymentDate.rejected, (state, action) => {
                state.loadingDisbursement = false;
            })

    }
})

export const {onRefreshGeneratePayment} = paymentInfoSlice.actions;

export const paymentInfoSelectors = (state) => state.paymentInfo;
export default paymentInfoSlice.reducer;